var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from "react";
import "react-table/react-table.css";
import { Button, Checkbox, Dimmer, Form, Loader, Message, Modal, Table } from "semantic-ui-react";
import ErrorDisplay from "../ErrorDisplay";
import { fetchRnaCatalog, RelevantCatalogType } from "../kit/automated-pro/RnaCatalog";
import { CatalogMode, deleteWithAuthn, getWithAuthn, postJsonWithAuthn } from "../RequestHelpers";
import { presetScaleEventsTable } from "./ChromogenPresetScalesPage";
var plexityOptions = [
    { key: 1, text: "ONE PLEX", value: 1 },
    { key: 2, text: "TWO PLEX", value: 2 }
];
var editModeOptions = [
    { key: "CONSUMER", text: "CONSUMER", value: "CONSUMER" },
    { key: "ADMIN", text: "ADMIN", value: "ADMIN" }
];
var ProDetectPresetScalesPage = /** @class */ (function (_super) {
    __extends(ProDetectPresetScalesPage, _super);
    function ProDetectPresetScalesPage(props) {
        var _this = _super.call(this, props) || this;
        _this.loadCatalog = function () {
            _this.setState({ loading: true, error: false }, function () {
                Promise.all([
                    fetchRnaCatalog(CatalogMode.Internal, RelevantCatalogType.Initial),
                    getWithAuthn("/admin/pro-detect/preset-scales/events")
                        .then(function (resp) { return resp.json(); })
                ])
                    .then(function (_a) {
                    var catalog = _a[0], events = _a[1];
                    _this.setState({
                        platforms: catalog.proPlatforms,
                        scales: catalog.presetScales.presetProDetectScales,
                        events: events,
                        loading: false
                    });
                })
                    .catch(function (err) {
                    console.error("Failed to load Pro Detect preset scales:", err);
                    _this.setState({ loading: false, error: true });
                });
            });
        };
        _this.openAddModal = function () {
            _this.setState({
                modalOpen: true,
                editingScale: undefined,
                formState: emptyForm(),
                formErrors: [],
                formSuccess: false
            });
        };
        _this.openEditModal = function (scale) {
            _this.setState({
                modalOpen: true,
                editingScale: scale,
                formState: scaleToForm(scale),
                formErrors: [],
                formSuccess: false
            });
        };
        _this.closeModal = function () {
            _this.setState({ modalOpen: false }, _this.loadCatalog);
        };
        _this.onPlatformChange = function (_, d) {
            _this.setState(function (s) { return ({ formState: __assign(__assign({}, s.formState), { platform: d.value }) }); });
        };
        _this.onPlexityChange = function (_, d) {
            _this.setState(function (s) { return ({ formState: __assign(__assign({}, s.formState), { plexity: String(d.value) }) }); });
        };
        _this.onEditModesChange = function (_, d) {
            _this.setState(function (s) { return ({ formState: __assign(__assign({}, s.formState), { editModes: d.value }) }); });
        };
        _this.onInputChange = function (e) {
            var _a = e.currentTarget, name = _a.name, value = _a.value;
            _this.setState(function (s) {
                var _a;
                return ({ formState: __assign(__assign({}, s.formState), (_a = {}, _a[name] = value, _a)) });
            });
        };
        _this.onActiveChange = function (_, d) {
            _this.setState(function (s) { var _a; return ({ formState: __assign(__assign({}, s.formState), { active: (_a = d.checked) !== null && _a !== void 0 ? _a : false }) }); });
        };
        _this.onIsProFlowChange = function (_, d) {
            _this.setState(function (s) { var _a; return ({ formState: __assign(__assign({}, s.formState), { isProFlow: (_a = d.checked) !== null && _a !== void 0 ? _a : false }) }); });
        };
        _this.onToggleInactive = function () {
            _this.setState(function (s) { return ({ showInactive: !s.showInactive }); });
        };
        _this.onSortChange = function (col) {
            _this.setState(function (s) { return ({
                sortColumn: col,
                sortDirection: s.sortColumn === col && s.sortDirection === "asc" ? "desc" : "asc"
            }); });
        };
        _this.submitForm = function () {
            var _a = _this.state, formState = _a.formState, editingScale = _a.editingScale;
            if (editingScale && !window.confirm("You are about to update the reagent values for this preset scale. " +
                "This action retroactively updates kits that reference it. Continue?")) {
                return;
            }
            var body = editingScale ? {
                oldUnits: editingScale.units,
                units: parseInt(formState.units, 10),
                oldUnitsLabel: editingScale.unitsLabel,
                unitsLabel: formState.unitsLabel,
                oldPretreatADewaxUl: editingScale.pretreatADewaxUl,
                pretreatADewaxUl: parseInt(formState.pretreatADewaxUl, 10),
                oldPretreatBAntigenRetrievalUl: editingScale.pretreatBAntigenRetrievalUl,
                pretreatBAntigenRetrievalUl: parseInt(formState.pretreatBAntigenRetrievalUl, 10),
                oldPretreatBloxolUl: editingScale.pretreatBloxolUl,
                pretreatBloxolUl: parseInt(formState.pretreatBloxolUl, 10),
                oldDetectAUl: editingScale.detectAUl,
                detectAUl: parseInt(formState.detectAUl, 10),
                oldDetectBPmol: editingScale.detectBPmol,
                detectBPmol: parseInt(formState.detectBPmol, 10),
                oldDetectBConcentration: editingScale.detectBConcentration,
                detectBConcentration: parseInt(formState.detectBConcentration, 10),
                oldDetectBUl: editingScale.detectBUl,
                detectBUl: parseInt(formState.detectBUl, 10),
                oldDetectCUl: editingScale.detectCUl,
                detectCUl: parseInt(formState.detectCUl, 10),
                oldDetectAntiHaptenUl: editingScale.detectAntiHaptenUl,
                detectAntiHaptenUl: parseInt(formState.detectAntiHaptenUl, 10),
                oldDetectTyramideUl: editingScale.detectTyramideUl,
                detectTyramideUl: parseInt(formState.detectTyramideUl, 10),
                oldDetectEnzymeApUl: editingScale.detectEnzymeApUl,
                detectEnzymeApUl: parseInt(formState.detectEnzymeApUl, 10),
                oldDetectEnzymeHrpUl: editingScale.detectEnzymeHrpUl,
                detectEnzymeHrpUl: parseInt(formState.detectEnzymeHrpUl, 10),
                oldDetectHrpQuencherUl: editingScale.detectHrpQuencherUl,
                detectHrpQuencherUl: parseInt(formState.detectHrpQuencherUl, 10),
                oldPostProcessAUl: editingScale.postProcessAUl,
                postProcessAUl: parseInt(formState.postProcessAUl, 10),
                oldPostProcessBUl: editingScale.postProcessBUl,
                postProcessBUl: parseInt(formState.postProcessBUl, 10),
                oldPreHybridizationUl: editingScale.preHybridizationUl,
                preHybridizationUl: parseInt(formState.preHybridizationUl, 10),
                oldActive: editingScale.active,
                active: formState.active,
                oldEffectiveDate: editingScale.effectiveDate,
                effectiveDate: formState.effectiveDate || null,
                oldEditModes: editingScale.editModes,
                editModes: formState.editModes
            } : {
                platform: formState.platform,
                plexity: parseInt(formState.plexity, 10),
                isProFlow: formState.isProFlow,
                units: parseInt(formState.units, 10),
                unitsLabel: formState.unitsLabel,
                pretreatADewaxUl: parseInt(formState.pretreatADewaxUl, 10),
                pretreatBAntigenRetrievalUl: parseInt(formState.pretreatBAntigenRetrievalUl, 10),
                pretreatBloxolUl: parseInt(formState.pretreatBloxolUl, 10),
                detectAUl: parseInt(formState.detectAUl, 10),
                detectBPmol: parseInt(formState.detectBPmol, 10),
                detectBConcentration: parseInt(formState.detectBConcentration, 10),
                detectBUl: parseInt(formState.detectBUl, 10),
                detectCUl: parseInt(formState.detectCUl, 10),
                detectAntiHaptenUl: parseInt(formState.detectAntiHaptenUl, 10),
                detectTyramideUl: parseInt(formState.detectTyramideUl, 10),
                detectEnzymeApUl: parseInt(formState.detectEnzymeApUl, 10),
                detectEnzymeHrpUl: parseInt(formState.detectEnzymeHrpUl, 10),
                detectHrpQuencherUl: parseInt(formState.detectHrpQuencherUl, 10),
                postProcessAUl: parseInt(formState.postProcessAUl, 10),
                postProcessBUl: parseInt(formState.postProcessBUl, 10),
                preHybridizationUl: parseInt(formState.preHybridizationUl, 10),
                active: formState.active,
                effectiveDate: formState.effectiveDate || null,
                editModes: formState.editModes
            };
            var path = editingScale
                ? "/admin/pro-detect/preset-scales/update/" + editingScale.id
                : "/admin/pro-detect/preset-scales/add";
            _this.setState({ formLoading: true, formErrors: [], formSuccess: false }, function () {
                postJsonWithAuthn(path, JSON.stringify(body))
                    .then(function (resp) {
                    if (resp.ok) {
                        _this.setState({ formLoading: false, formSuccess: true });
                    }
                    else if (resp.status === 400) {
                        return resp.json().then(function (err) {
                            _this.setState({ formLoading: false, formErrors: err.errors });
                        });
                    }
                    else {
                        _this.setState({
                            formLoading: false,
                            formErrors: [{ path: "/", msg: "An unexpected error occurred" }]
                        });
                    }
                    return undefined;
                })
                    .catch(function (err) { return console.error("Failed to save Pro Detect preset scale:", err); });
            });
        };
        _this.addPresets = function () {
            if (!window.confirm("Add 14 preset scales for Leica, Oncore Pro X, Neopath Pro, Bond III, Roche, and Manual?")) {
                return;
            }
            _this.setState({ bulkAdding: true }, function () {
                postJsonWithAuthn("/admin/pro-detect/preset-scales/add-presets", JSON.stringify({}))
                    .then(function () { return _this.setState({ bulkAdding: false }, _this.loadCatalog); })
                    .catch(function (err) {
                    console.error("Failed to add presets:", err);
                    _this.setState({ bulkAdding: false });
                });
            });
        };
        _this.deleteScale = function (id) {
            if (!window.confirm("Delete scale #" + id + "?")) {
                return;
            }
            deleteWithAuthn("/admin/pro-detect/preset-scales/" + id)
                .then(function (resp) {
                if (resp.ok) {
                    return _this.loadCatalog();
                }
                else if (resp.status === 400) {
                    return resp.json().then(function (errorResp) {
                        window.alert(errorResp.errors.map(function (e) { return e.msg; }).join("\n"));
                    });
                }
                else {
                    window.alert("An unexpected error occurred");
                }
                return undefined;
            })
                .catch(function (err) { return console.error("Failed to delete Pro Detect preset scale:", err); });
        };
        _this.state = {
            loading: false,
            error: false,
            platforms: [],
            modalOpen: false,
            formState: emptyForm(),
            formLoading: false,
            formErrors: [],
            formSuccess: false,
            showInactive: false,
            bulkAdding: false,
            sortColumn: "id",
            sortDirection: "asc"
        };
        return _this;
    }
    ProDetectPresetScalesPage.prototype.componentDidMount = function () {
        this.loadCatalog();
    };
    ProDetectPresetScalesPage.prototype.render = function () {
        var _this = this;
        var _a = this.state, loading = _a.loading, error = _a.error, scales = _a.scales, events = _a.events, platforms = _a.platforms, modalOpen = _a.modalOpen, formState = _a.formState, formLoading = _a.formLoading, formErrors = _a.formErrors, formSuccess = _a.formSuccess, editingScale = _a.editingScale, showInactive = _a.showInactive, bulkAdding = _a.bulkAdding, sortColumn = _a.sortColumn, sortDirection = _a.sortDirection;
        var visibleScales = scales === null || scales === void 0 ? void 0 : scales.filter(function (s) { return showInactive || s.active; });
        var platformOptions = platforms.map(function (p) { return ({ key: p.id, text: p.alias, value: p.id }); });
        var sortedScales = visibleScales === null || visibleScales === void 0 ? void 0 : visibleScales.slice().sort(function (a, b) {
            var _a, _b;
            var cmp = 0;
            switch (sortColumn) {
                case "id":
                    cmp = a.id - b.id;
                    break;
                case "platform":
                    cmp = a.platform.label.localeCompare(b.platform.label);
                    break;
                case "plexity":
                    cmp = a.plexity - b.plexity;
                    break;
                case "isProFlow":
                    cmp = Number(a.isProFlow) - Number(b.isProFlow);
                    break;
                case "units":
                    cmp = a.units - b.units;
                    break;
                case "unitsLabel":
                    cmp = a.unitsLabel.localeCompare(b.unitsLabel);
                    break;
                case "pretreatADewaxUl":
                    cmp = a.pretreatADewaxUl - b.pretreatADewaxUl;
                    break;
                case "pretreatBAntigenRetrievalUl":
                    cmp = a.pretreatBAntigenRetrievalUl - b.pretreatBAntigenRetrievalUl;
                    break;
                case "pretreatBloxolUl":
                    cmp = a.pretreatBloxolUl - b.pretreatBloxolUl;
                    break;
                case "detectAUl":
                    cmp = a.detectAUl - b.detectAUl;
                    break;
                case "detectBPmol":
                    cmp = a.detectBPmol - b.detectBPmol;
                    break;
                case "detectBConcentration":
                    cmp = a.detectBConcentration - b.detectBConcentration;
                    break;
                case "detectBUl":
                    cmp = a.detectBUl - b.detectBUl;
                    break;
                case "detectCUl":
                    cmp = a.detectCUl - b.detectCUl;
                    break;
                case "detectAntiHaptenUl":
                    cmp = a.detectAntiHaptenUl - b.detectAntiHaptenUl;
                    break;
                case "detectTyramideUl":
                    cmp = a.detectTyramideUl - b.detectTyramideUl;
                    break;
                case "detectEnzymeApUl":
                    cmp = a.detectEnzymeApUl - b.detectEnzymeApUl;
                    break;
                case "detectEnzymeHrpUl":
                    cmp = a.detectEnzymeHrpUl - b.detectEnzymeHrpUl;
                    break;
                case "detectHrpQuencherUl":
                    cmp = a.detectHrpQuencherUl - b.detectHrpQuencherUl;
                    break;
                case "postProcessAUl":
                    cmp = a.postProcessAUl - b.postProcessAUl;
                    break;
                case "postProcessBUl":
                    cmp = a.postProcessBUl - b.postProcessBUl;
                    break;
                case "preHybridizationUl":
                    cmp = a.preHybridizationUl - b.preHybridizationUl;
                    break;
                case "active":
                    cmp = Number(a.active) - Number(b.active);
                    break;
                case "effectiveDate":
                    cmp = ((_a = a.effectiveDate) !== null && _a !== void 0 ? _a : "").localeCompare((_b = b.effectiveDate) !== null && _b !== void 0 ? _b : "");
                    break;
                case "editModes":
                    cmp = a.editModes.join(",").localeCompare(b.editModes.join(","));
                    break;
            }
            return sortDirection === "asc" ? cmp : -cmp;
        });
        var headerCell = function (col, label) {
            var active = sortColumn === col;
            var icon = active ? (sortDirection === "asc" ? " ▲" : " ▼") : "";
            return (React.createElement(Table.HeaderCell, { style: { cursor: "pointer", userSelect: "none", whiteSpace: "nowrap" }, onClick: function () { return _this.onSortChange(col); } },
                label,
                icon));
        };
        return (React.createElement("div", { style: { maxWidth: "1700px", margin: "0 auto", padding: "1rem" } },
            React.createElement("h2", null, "Pro Detect Preset Scales"),
            React.createElement(Message, { info: true, style: { marginBottom: "1.5rem" } },
                React.createElement(Message.Header, null, "How this page works"),
                React.createElement("p", { style: { marginTop: "0.75rem" } }, "Platform, plexity and units are locked after creation. Updating a scale retroactively updates the Pro Detect components and TSA chain values on kits that reference it."),
                React.createElement("p", null, "Active scales and scheduled effective dates are unique per platform, units and plexity.")),
            React.createElement(Dimmer.Dimmable, null,
                React.createElement(Dimmer, { active: loading, inverted: true },
                    React.createElement(Loader, null)),
                error && React.createElement(Message, { negative: true }, "Failed to load Pro Detect preset scales."),
                visibleScales && (React.createElement(React.Fragment, null,
                    React.createElement("div", { style: { marginBottom: "1rem", display: "flex", alignItems: "center", gap: "0.75rem" } },
                        React.createElement(Button, { icon: "plus", labelPosition: "left", label: "Add Scale", onClick: this.openAddModal }),
                        React.createElement(Button, { loading: bulkAdding, disabled: bulkAdding, onClick: this.addPresets }, "Add Preset Scales"),
                        React.createElement(Checkbox, { toggle: true, label: "Show inactive", checked: showInactive, onChange: this.onToggleInactive })),
                    React.createElement("div", { style: { overflowX: "auto" } },
                        React.createElement(Table, { striped: true, celled: true, compact: true },
                            React.createElement(Table.Header, null,
                                React.createElement(Table.Row, null,
                                    headerCell("id", "ID"),
                                    headerCell("platform", "Platform"),
                                    headerCell("plexity", "Plexity"),
                                    headerCell("isProFlow", "Pro Flow"),
                                    headerCell("units", "Units"),
                                    headerCell("unitsLabel", "Units Label"),
                                    headerCell("pretreatADewaxUl", "Pretreat A Dewax (mL)"),
                                    headerCell("pretreatBAntigenRetrievalUl", "Pretreat B Antigen Retrieval (mL)"),
                                    headerCell("pretreatBloxolUl", "Pretreat Bloxol (mL)"),
                                    headerCell("detectAUl", "Detect A (mL)"),
                                    headerCell("detectBPmol", "Detect B (pmol)"),
                                    headerCell("detectBConcentration", "Detect B Concentration"),
                                    headerCell("detectBUl", "Detect B (mL)"),
                                    headerCell("detectCUl", "Detect C (mL)"),
                                    headerCell("detectAntiHaptenUl", "Anti-Hapten (mL)"),
                                    headerCell("detectTyramideUl", "Tyramide (mL)"),
                                    headerCell("detectEnzymeApUl", "Enzyme AP (mL)"),
                                    headerCell("detectEnzymeHrpUl", "Enzyme HRP (mL)"),
                                    headerCell("detectHrpQuencherUl", "HRP Quencher (mL)"),
                                    headerCell("postProcessAUl", "Post-Process A (mL)"),
                                    headerCell("postProcessBUl", "Post-Process B (mL)"),
                                    headerCell("preHybridizationUl", "Pre-Hybridization (mL)"),
                                    headerCell("active", "Active"),
                                    headerCell("effectiveDate", "Effective Date"),
                                    headerCell("editModes", "Edit Modes"),
                                    React.createElement(Table.HeaderCell, null, "Actions"))),
                            React.createElement(Table.Body, null, sortedScales.map(function (scale) { return (React.createElement(ScaleRow, { key: scale.id, scale: scale, onEdit: _this.openEditModal, onDelete: _this.deleteScale })); }))))))),
            events && presetScaleEventsTable(events),
            React.createElement(Modal, { open: modalOpen, onClose: this.closeModal, closeIcon: true },
                React.createElement(Modal.Header, null, editingScale ? "Edit Scale #" + editingScale.id : "Add Pro Detect Preset Scale"),
                React.createElement(Modal.Content, null,
                    React.createElement(Dimmer.Dimmable, { as: Form, error: formErrors.length > 0 },
                        React.createElement(Dimmer, { active: formLoading, inverted: true },
                            React.createElement(Loader, null)),
                        formSuccess && React.createElement(Message, { positive: true }, "Saved successfully."),
                        React.createElement(ErrorDisplay, { errors: formErrors, errorPath: "/" }),
                        React.createElement(Form.Select, { label: "Platform", options: platformOptions, value: formState.platform, onChange: this.onPlatformChange, disabled: !!editingScale }),
                        React.createElement(Form.Select, { label: "Plexity", options: plexityOptions, value: formState.plexity, onChange: this.onPlexityChange, disabled: !!editingScale }),
                        React.createElement(Form.Field, null,
                            React.createElement(Checkbox, { label: "Pro Flow", checked: formState.isProFlow, onChange: this.onIsProFlowChange, disabled: !!editingScale })),
                        React.createElement(Form.Input, { label: "Units", type: "number", name: "units", value: formState.units, onChange: this.onInputChange }),
                        React.createElement(Form.Input, { label: "Units Label", type: "text", name: "unitsLabel", value: formState.unitsLabel, onChange: this.onInputChange }),
                        React.createElement(Form.Input, { label: "Pretreat A Dewax (uL)", type: "number", name: "pretreatADewaxUl", value: formState.pretreatADewaxUl, onChange: this.onInputChange }),
                        React.createElement(Form.Input, { label: "Pretreat B Antigen Retrieval (uL)", type: "number", name: "pretreatBAntigenRetrievalUl", value: formState.pretreatBAntigenRetrievalUl, onChange: this.onInputChange }),
                        React.createElement(Form.Input, { label: "Pretreat Bloxol (uL)", type: "number", name: "pretreatBloxolUl", value: formState.pretreatBloxolUl, onChange: this.onInputChange }),
                        React.createElement(Form.Input, { label: "Detect A (uL)", type: "number", name: "detectAUl", value: formState.detectAUl, onChange: this.onInputChange }),
                        React.createElement(Form.Input, { label: "Detect B (pmol)", type: "number", name: "detectBPmol", value: formState.detectBPmol, onChange: this.onInputChange }),
                        React.createElement(Form.Input, { label: "Detect B Concentration", type: "number", name: "detectBConcentration", value: formState.detectBConcentration, onChange: this.onInputChange }),
                        React.createElement(Form.Input, { label: "Detect B (uL)", type: "number", name: "detectBUl", value: formState.detectBUl, onChange: this.onInputChange }),
                        React.createElement(Form.Input, { label: "Detect C (uL)", type: "number", name: "detectCUl", value: formState.detectCUl, onChange: this.onInputChange }),
                        React.createElement(Form.Input, { label: "Detect Anti-Hapten (uL)", type: "number", name: "detectAntiHaptenUl", value: formState.detectAntiHaptenUl, onChange: this.onInputChange }),
                        React.createElement(Form.Input, { label: "Detect Tyramide (uL)", type: "number", name: "detectTyramideUl", value: formState.detectTyramideUl, onChange: this.onInputChange }),
                        React.createElement(Form.Input, { label: "Detect Enzyme AP (uL)", type: "number", name: "detectEnzymeApUl", value: formState.detectEnzymeApUl, onChange: this.onInputChange }),
                        React.createElement(Form.Input, { label: "Detect Enzyme HRP (uL)", type: "number", name: "detectEnzymeHrpUl", value: formState.detectEnzymeHrpUl, onChange: this.onInputChange }),
                        React.createElement(Form.Input, { label: "Detect HRP Quencher (uL)", type: "number", name: "detectHrpQuencherUl", value: formState.detectHrpQuencherUl, onChange: this.onInputChange }),
                        React.createElement(Form.Input, { label: "Post-Process A (uL)", type: "number", name: "postProcessAUl", value: formState.postProcessAUl, onChange: this.onInputChange }),
                        React.createElement(Form.Input, { label: "Post-Process B (uL)", type: "number", name: "postProcessBUl", value: formState.postProcessBUl, onChange: this.onInputChange }),
                        React.createElement(Form.Input, { label: "Pre-Hybridization (uL)", type: "number", name: "preHybridizationUl", value: formState.preHybridizationUl, onChange: this.onInputChange }),
                        React.createElement(Form.Select, { label: "Edit Modes", options: editModeOptions, value: formState.editModes, onChange: this.onEditModesChange, multiple: true }),
                        React.createElement(Form.Field, null,
                            React.createElement(Checkbox, { label: "Active", checked: formState.active, onChange: this.onActiveChange })),
                        React.createElement(Form.Field, null,
                            React.createElement("label", null, "Effective Date (optional)"),
                            React.createElement("input", { type: "date", name: "effectiveDate", value: formState.effectiveDate, onChange: this.onInputChange }),
                            React.createElement("div", { style: { marginTop: "0.5rem", fontSize: "0.85em", color: "#666" } }, "Dates are relative to the Los Angeles timezone")),
                        React.createElement(Button, { primary: true, onClick: this.submitForm }, editingScale ? "Update" : "Add"),
                        React.createElement(Button, { onClick: this.closeModal }, "Cancel"))))));
    };
    return ProDetectPresetScalesPage;
}(React.Component));
export default ProDetectPresetScalesPage;
var ulToMl = function (ul) { return parseFloat((ul / 1000).toPrecision(6)); };
var ScaleRow = /** @class */ (function (_super) {
    __extends(ScaleRow, _super);
    function ScaleRow() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleEdit = function () { return _this.props.onEdit(_this.props.scale); };
        _this.handleDelete = function () { return _this.props.onDelete(_this.props.scale.id); };
        return _this;
    }
    ScaleRow.prototype.render = function () {
        var _a;
        var scale = this.props.scale;
        return (React.createElement(Table.Row, null,
            React.createElement(Table.Cell, null, scale.id),
            React.createElement(Table.Cell, null, scale.platform.label),
            React.createElement(Table.Cell, null, scale.plexity === 2 ? "TwoPlex" : "OnePlex"),
            React.createElement(Table.Cell, null, scale.isProFlow ? "Yes" : "No"),
            React.createElement(Table.Cell, null, scale.units),
            React.createElement(Table.Cell, null, scale.unitsLabel),
            React.createElement(Table.Cell, null, ulToMl(scale.pretreatADewaxUl)),
            React.createElement(Table.Cell, null, ulToMl(scale.pretreatBAntigenRetrievalUl)),
            React.createElement(Table.Cell, null, ulToMl(scale.pretreatBloxolUl)),
            React.createElement(Table.Cell, null, ulToMl(scale.detectAUl)),
            React.createElement(Table.Cell, null, scale.detectBPmol),
            React.createElement(Table.Cell, null, scale.detectBConcentration),
            React.createElement(Table.Cell, null, ulToMl(scale.detectBUl)),
            React.createElement(Table.Cell, null, ulToMl(scale.detectCUl)),
            React.createElement(Table.Cell, null, ulToMl(scale.detectAntiHaptenUl)),
            React.createElement(Table.Cell, null, ulToMl(scale.detectTyramideUl)),
            React.createElement(Table.Cell, null, ulToMl(scale.detectEnzymeApUl)),
            React.createElement(Table.Cell, null, ulToMl(scale.detectEnzymeHrpUl)),
            React.createElement(Table.Cell, null, ulToMl(scale.detectHrpQuencherUl)),
            React.createElement(Table.Cell, null, ulToMl(scale.postProcessAUl)),
            React.createElement(Table.Cell, null, ulToMl(scale.postProcessBUl)),
            React.createElement(Table.Cell, null, ulToMl(scale.preHybridizationUl)),
            React.createElement(Table.Cell, null, scale.active ? "Yes" : "No"),
            React.createElement(Table.Cell, null, (_a = scale.effectiveDate) !== null && _a !== void 0 ? _a : "-"),
            React.createElement(Table.Cell, null, scale.editModes.join(", ")),
            React.createElement(Table.Cell, null,
                React.createElement(Button, { size: "tiny", icon: "edit", onClick: this.handleEdit }),
                React.createElement(Button, { size: "tiny", icon: "trash", negative: true, onClick: this.handleDelete }))));
    };
    return ScaleRow;
}(React.PureComponent));
var emptyForm = function () { return ({
    platform: "",
    plexity: "1",
    isProFlow: false,
    units: "",
    unitsLabel: "",
    pretreatADewaxUl: "",
    pretreatBAntigenRetrievalUl: "",
    pretreatBloxolUl: "",
    detectAUl: "",
    detectBPmol: "",
    detectBConcentration: "",
    detectBUl: "",
    detectCUl: "",
    detectAntiHaptenUl: "",
    detectTyramideUl: "",
    detectEnzymeApUl: "",
    detectEnzymeHrpUl: "",
    detectHrpQuencherUl: "",
    postProcessAUl: "",
    postProcessBUl: "",
    preHybridizationUl: "",
    active: false,
    effectiveDate: "",
    editModes: []
}); };
var scaleToForm = function (scale) {
    var _a;
    return ({
        platform: scale.platform.id,
        plexity: String(scale.plexity),
        isProFlow: scale.isProFlow,
        units: String(scale.units),
        unitsLabel: scale.unitsLabel,
        pretreatADewaxUl: String(scale.pretreatADewaxUl),
        pretreatBAntigenRetrievalUl: String(scale.pretreatBAntigenRetrievalUl),
        pretreatBloxolUl: String(scale.pretreatBloxolUl),
        detectAUl: String(scale.detectAUl),
        detectBPmol: String(scale.detectBPmol),
        detectBConcentration: String(scale.detectBConcentration),
        detectBUl: String(scale.detectBUl),
        detectCUl: String(scale.detectCUl),
        detectAntiHaptenUl: String(scale.detectAntiHaptenUl),
        detectTyramideUl: String(scale.detectTyramideUl),
        detectEnzymeApUl: String(scale.detectEnzymeApUl),
        detectEnzymeHrpUl: String(scale.detectEnzymeHrpUl),
        detectHrpQuencherUl: String(scale.detectHrpQuencherUl),
        postProcessAUl: String(scale.postProcessAUl),
        postProcessBUl: String(scale.postProcessBUl),
        preHybridizationUl: String(scale.preHybridizationUl),
        active: scale.active,
        effectiveDate: (_a = scale.effectiveDate) !== null && _a !== void 0 ? _a : "",
        editModes: scale.editModes
    });
};
//# sourceMappingURL=ProDetectPresetScalesPage.js.map


//////////////////
// WEBPACK FOOTER
// ../common/build/dist/admin/ProDetectPresetScalesPage.js
// module id = 1481
// module chunks = 0